import React from "react";

import { StyledSVG } from "../StyledIcon";

export const SecurityIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M6 9.35294L7.83333 11L12 7"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4508 4.65109C14.7876 4.8212 15 5.16639 15 5.5437V8.88551C15 12.3317 10.8169 14.9836 9.43725 15.7645C9.16433 15.919 8.83904 15.9191 8.56607 15.7646C7.18584 14.9839 3 12.3318 3 8.88551V5.56216C3 5.17527 3.22318 4.82309 3.57303 4.6579L8.76034 2.20859C9.0391 2.07696 9.36299 2.08127 9.63815 2.22025L14.4508 4.65109Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </StyledSVG>
  );
};
